import * as React from 'react';

import ImagePreviewer from '~shared/components/ImageField/ImagePreviewer';
import { ImageResource } from '~teacher/models/quizzes';

interface QuestionImagePreviewerProps {
  image?: ImageResource;
  /** is the question in Disabled mode? */
  isDisabled?: boolean;
  /** Callback action when the image is changed or removed. */
  onChangeImage?: (imageURL: string) => void;
}

export function QuestionImagePreviewer({ image }: QuestionImagePreviewerProps) {
  return (
    <ImagePreviewer
      imageStyle="max-h-70 rounded-2"
      imageURL={image?.urlS}
      containerStyle="max-w-70 max-h-70 mt-6 lg:mt-0 ml-14 lg:ml-0 lg:row-span-2 lg:col-start-2 lg:text-right rounded-2"
      showOutline={true}
      allowZoom={true}
      zoomImageURL={image?.url}
    />
  );
}
